import { Map } from 'immutable';

import {
  ADD,
  ADD_MULTIPLE,
  UPDATE,
  REMOVE,
  UPCOMING_DEEDS_LOADED,
  PAST_DEEDS_LOADED,
  UPDATE_DEED_PARTIALLY,
} from './constants';
import Deed from './model';

export type AddAction = {
  type: typeof ADD;
  deed: Deed;
};
export const addAction = (deed: Deed): AddAction => ({
  type: ADD,
  deed,
});

export type AddMultipleAction = {
  type: typeof ADD_MULTIPLE;
  deeds: Map<string, Deed>;
};
export const addMultipleAction = (deeds: Map<string, Deed>): AddMultipleAction => ({
  type: ADD_MULTIPLE,
  deeds,
});

export type UpdateAction = {
  type: typeof UPDATE;
  deed: Deed;
};
export type UpdateDeedPartiallyAction = {
  type: typeof UPDATE_DEED_PARTIALLY;
  deedFields: Partial<Deed>;
};

export const updateAction = (deed: Deed): UpdateAction => ({
  type: UPDATE,
  deed,
});

export const updateDeedPartiallyAction = (
  deedFields: Partial<Deed>
): UpdateDeedPartiallyAction => ({
  type: UPDATE_DEED_PARTIALLY,
  deedFields,
});

export type RemoveAction = {
  type: typeof REMOVE;
  id: string;
};
export const removeAction = (id: string): RemoveAction => ({
  type: REMOVE,
  id,
});

export type UpcomingDeedsLoadedAction = {
  type: typeof UPCOMING_DEEDS_LOADED;
  userId: string;
};
export const upcomingDeedsLoadedAction = (userId: string): UpcomingDeedsLoadedAction => ({
  type: UPCOMING_DEEDS_LOADED,
  userId,
});

export type PastDeedsLoadedAction = {
  type: typeof PAST_DEEDS_LOADED;
  userId: string;
};
export const pastDeedsLoadedAction = (userId: string): PastDeedsLoadedAction => ({
  type: PAST_DEEDS_LOADED,
  userId,
});

export type DeedActions =
  | AddAction
  | AddMultipleAction
  | RemoveAction
  | UpdateAction
  | UpcomingDeedsLoadedAction
  | UpdateDeedPartiallyAction
  | PastDeedsLoadedAction;
